import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { IconButton } from '@mui/material';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI, IconPaletteUI } from '../Interface';
import { getIcon } from '../../utils/helper';

export const TaskDowntimeReasonFields = ({ viewField, addField }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    if (!viewField) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleIconSelect = (iconName) => {
    setFieldValue('icon', iconName);
    handlePopoverClose();
  };

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="code"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Leállás kódja" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.code} />}
          disabled={viewField || addField}
          InputLabelProps={{ shrink: values.code && values.code !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Leállás megnevezése" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-1 col-span-4 pt-4">
        <div onClick={handlePopoverOpen} className="flex gap-3 cursor-pointer items-center">
          <IconButton sx={{ margin: 0, padding: 0 }}>{getIcon(values?.icon, '1.7rem')}</IconButton>
          Ikon
        </div>
        <IconPaletteUI
          handleIconSelect={handleIconSelect}
          anchorEl={anchorEl}
          handlePopoverClose={handlePopoverClose}
        />
        {<FormErrorUI message={errors.icon} />}
      </div>
      <div className="md:col-span-1 col-span-4 pt-2">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};
